/* ============================================================
   AirStore CRO Theme — JS: cart AJAX, countdown, popups, reveals
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var money = function (cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  /* ---------------- Toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2600);
  }

  /* ---------------- Cart state ---------------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateBadge(cart) {
    var badge = $('#cartCount');
    if (!badge) return;
    if (cart.item_count > 0) {
      badge.hidden = false;
      badge.textContent = cart.item_count;
    } else {
      badge.hidden = true;
    }
  }

  function renderDrawer(cart) {
    updateBadge(cart);
    var body = $('#drawerBody');
    var foot = $('#drawerFoot');
    var titleN = $('#drawerCount');
    if (titleN) titleN.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-empty-state">' +
        '<span class="emoji">🛒</span>' +
        '<h3>Количката е празна</h3>' +
        '<p>Добави продукт, за да продължиш. Офертата изтича скоро!</p>' +
        '<button class="btn-cta" style="margin-top:8px;width:auto;padding:0 32px;min-height:52px;font-size:14px" data-close-cart>Разгледай офертата</button>' +
        '</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';

    var html = '<div class="freeship-box">' +
      '<p>🚚 Доставка с Еконт за 1–3 дни — <b>преглед и тест при куриера</b></p></div>';

    cart.items.forEach(function (item) {
      html += '<div class="cart-line">';
      if (item.image) html += '<img src="' + item.image + '&width=128" alt="">';
      html += '<div class="info"><div style="display:flex;justify-content:space-between;gap:8px">' +
        '<div><div class="name">' + item.product_title + '</div>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<div class="variant">' + item.variant_title + '</div>';
      }
      html += '</div>' +
        '<button class="remove" data-remove="' + item.key + '" aria-label="Премахни">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
        '</button></div>' +
        '<div class="row">' +
        '<div class="qty-stepper">' +
        '<button data-change="' + item.key + '" data-delta="-1" aria-label="Намали">−</button>' +
        '<span class="q">' + item.quantity + '</span>' +
        '<button data-change="' + item.key + '" data-delta="1" aria-label="Увеличи">+</button>' +
        '</div>' +
        '<span class="price">' + money(item.final_line_price) + '</span>' +
        '</div></div></div>';
    });

    /* upsells from markup template (rendered server-side, hidden) */
    var upsellTpl = $('#upsellTemplate');
    if (upsellTpl) html += upsellTpl.innerHTML;

    body.innerHTML = html;

    if (foot) {
      $('#drawerSubtotal').textContent = money(cart.total_price);
    }
  }

  function refreshCart(openAfter) {
    fetchCart().then(function (cart) {
      renderDrawer(cart);
      if (openAfter) openDrawer();
    });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      toast('✓ Добавено в количката');
      refreshCart(true);
    }).catch(function () {
      toast('⚠ Грешка — опитай отново');
    });
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { refreshCart(false); });
  }

  /* ---------------- Drawer open/close ---------------- */
  function openDrawer() {
    $('#cartDrawer').classList.add('open');
    $('#drawerOverlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    $('#cartDrawer').classList.remove('open');
    $('#drawerOverlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ---------------- Global click delegation ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var openBtn = t.closest('[data-open-cart]');
    if (openBtn) { e.preventDefault(); refreshCart(true); return; }

    var closeBtn = t.closest('[data-close-cart]');
    if (closeBtn) { e.preventDefault(); closeDrawer(); return; }

    var addBtn = t.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var variant = addBtn.getAttribute('data-variant-id');
      var qty = parseInt(addBtn.getAttribute('data-qty') || '1', 10);
      addBtn.disabled = true;
      var original = addBtn.innerHTML;
      addBtn.innerHTML = '⏳ Добавя се...';
      addToCart(variant, qty).finally(function () {
        addBtn.disabled = false;
        addBtn.innerHTML = original;
      });
      return;
    }

    var changeBtn = t.closest('[data-change]');
    if (changeBtn) {
      e.preventDefault();
      var key = changeBtn.getAttribute('data-change');
      var delta = parseInt(changeBtn.getAttribute('data-delta'), 10);
      var qEl = changeBtn.parentElement.querySelector('.q');
      var current = parseInt(qEl.textContent, 10);
      changeLine(key, Math.max(0, current + delta));
      return;
    }

    var removeBtn = t.closest('[data-remove]');
    if (removeBtn) { e.preventDefault(); changeLine(removeBtn.getAttribute('data-remove'), 0); return; }

    var copyBtn = t.closest('[data-copy-promo]');
    if (copyBtn) {
      e.preventDefault();
      var code = copyBtn.getAttribute('data-copy-promo');
      if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
      toast('✓ Промо кодът ' + code + ' е копиран');
      return;
    }

    var upsellBtn = t.closest('[data-upsell-add]');
    if (upsellBtn) {
      e.preventDefault();
      addToCart(upsellBtn.getAttribute('data-upsell-add'), 1);
      return;
    }

    /* FAQ accordion */
    var faqQ = t.closest('.faq-q');
    if (faqQ) {
      var item = faqQ.parentElement;
      var answer = item.querySelector('.faq-a');
      var isOpen = item.classList.toggle('open');
      answer.style.maxHeight = isOpen ? answer.scrollHeight + 'px' : '0px';
      return;
    }
  });

  /* ---------------- Gallery thumbs ---------------- */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-gallery-thumb]');
    if (!th) return;
    var main = $('#galleryMainImg');
    if (!main) return;
    main.src = th.getAttribute('data-full');
    $$('.gallery-thumbs button').forEach(function (b) { b.classList.remove('active'); });
    th.classList.add('active');
  });

  /* ---------------- Countdown to midnight ---------------- */
  function tickCountdown() {
    var els = $$('[data-countdown]');
    if (!els.length) return;
    var now = new Date();
    var end = new Date(now); end.setHours(23, 59, 59, 999);
    var diff = Math.max(0, end - now);
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var pad = function (x) { return (x < 10 ? '0' : '') + x; };
    var txt = pad(h) + '<span class="colon">:</span>' + pad(m) + '<span class="colon">:</span>' + pad(s);
    els.forEach(function (el) { el.innerHTML = txt; });
  }
  tickCountdown();
  setInterval(tickCountdown, 1000);

  /* ---------------- Live viewers ---------------- */
  var viewerEl = $('#viewerCount');
  if (viewerEl) {
    setInterval(function () {
      var c = parseInt(viewerEl.textContent, 10) || 14;
      var next = c + (Math.random() > 0.5 ? 1 : -1);
      next = Math.min(26, Math.max(8, next));
      viewerEl.textContent = next;
    }, 4000);
  }

  /* ---------------- Stock bar fill ---------------- */
  var stockFill = $('#stockFill');
  if (stockFill) {
    requestAnimationFrame(function () {
      stockFill.style.width = stockFill.getAttribute('data-width') + '%';
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('in');
        revealObserver.unobserve(en.target);
      }
    });
  }, { rootMargin: '-60px' });
  $$('.reveal').forEach(function (el) { revealObserver.observe(el); });

  /* ---------------- Sticky bar ---------------- */
  var sticky = $('#stickyBar');
  if (sticky && document.body.getAttribute('data-template') !== 'cart') {
    window.addEventListener('scroll', function () {
      sticky.classList.toggle('visible', window.scrollY > 620 && !$('#cartDrawer').classList.contains('open'));
    }, { passive: true });
  }

  /* ---------------- Promo popup (exit intent + timed) ---------------- */
  var popup = $('#promoPopup');
  var popupOverlay = $('#popupOverlay');
  if (popup && !sessionStorage.getItem('promo-dismissed')) {
    var shown = false;
    var showPopup = function () {
      if (shown || sessionStorage.getItem('promo-dismissed')) return;
      if ($('#cartDrawer').classList.contains('open')) return;
      shown = true;
      popup.classList.add('open');
      popupOverlay.classList.add('open');
    };
    var hidePopup = function () {
      sessionStorage.setItem('promo-dismissed', '1');
      popup.classList.remove('open');
      popupOverlay.classList.remove('open');
    };
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0 && window.innerWidth >= 1024) showPopup();
    });
    setTimeout(showPopup, 28000);
    popupOverlay.addEventListener('click', hidePopup);
    $$('[data-popup-close]').forEach(function (b) { b.addEventListener('click', hidePopup); });
    var claim = $('[data-popup-claim]');
    if (claim) {
      claim.addEventListener('click', function () {
        var code = claim.getAttribute('data-popup-claim');
        if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
        toast('✓ Кодът ' + code + ' е копиран — ползвай го в checkout');
        hidePopup();
      });
    }
  }

  /* ---------------- Init cart badge ---------------- */
  refreshCart(false);
})();
